//#region src/services/groupSubscription/IGroupSubscriptionService.ts
const GROUP_SUBSCRIPTION_SERVICE_IDENT = "org.aimystic.service.GroupSubscription";

//#endregion
export { GROUP_SUBSCRIPTION_SERVICE_IDENT };
//# sourceMappingURL=IGroupSubscriptionService.js.map